import {
  Component,
  Input,
  Output,
  EventEmitter,
  inject,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { AppButtonComponent } from '@app/shared/components/app-button/app-button.component';

@Component({
  selector: 'app-add-lot-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    DialogModule,
    InputTextModule,
    ButtonModule,
    ToastModule,
    AppButtonComponent,
  ],
  providers: [MessageService],
  templateUrl: './add-lot-dialog.component.html',
  styleUrl: './add-lot-dialog.component.css',
})
export class AddLotDialogComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly translateService = inject(TranslateService);
  private readonly messageService = inject(MessageService);

  @Input() visible = false;
  @Input() skuCode: string | null = null;
  @Input() skuName: string | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirm = new EventEmitter<string>();

  lotForm!: FormGroup;

  ngOnInit(): void {
    this.initializeForm();
  }

  private initializeForm(): void {
    this.lotForm = this.fb.group({
      lotNumber: ['', [Validators.required]],
    });
  }

  onConfirm(): void {
    if (!this.lotForm.valid) {
      this.lotForm.markAllAsTouched();
      this.messageService.add({
        severity: 'error',
        summary: this.translateService.instant('common.messages.error'),
        detail: this.translateService.instant('inbound.receive.lot_number_required'),
        life: 3000,
      });
      return;
    }

    const lotNumber = this.lotForm.get('lotNumber')?.value?.trim();
    if (lotNumber) {
      this.confirm.emit(lotNumber);
      this.onCancel();
    }
  }

  onCancel(): void {
    this.lotForm.reset();
    this.visible = false;
    this.visibleChange.emit(false);
  }
}

